import React, { useEffect } from "react";
import clsx from 'clsx';
import {
    ServiceDialog,
} from '../../../../../../styling/Styles';
import '../../../../../../styling/Styles.css';
import CreateDataElementSnackBar from '../../../../../CreateDataElementSnackBar';
import DropdownMechanismFixLabel from '../../../../../GeneralComponents/DropdownMechanismFixLabel';
import FormRowComponent from './FormRowComponent'
import EditFormFunctionsRow from './EditFormFunctionsRow';
import GenerateFormBlock from './GenerateFormBlock';

const checkIfRadiosExist = (componentsInfo) => {

    let exists = -1;

    componentsInfo.forEach( (comp, index) => {
        if(comp === 'radio'){
            exists = index;
        }
    })

    return exists;
}

//  This is a component that renders the pop up window of an edited form.
const EditPopUpForm = (props) => {

    const {
        editor,
        selectedProject,
        selectedPage,
        savedPageClicked,
    } = props;
    const [init,setInit] = React.useState(false);
    const [openAlert, setOpenAlert] = React.useState(false);
    const [clickedEdit, setClickedEdit] = React.useState(false);
    const ElementTypes = ['input type', 'radio type', 'textarea type','button type']
    const [added, setAdded] = React.useState(false);
    const [dataElementName, setDataElementName] = React.useState('');
    const [producedBlockName, setProducedBlockName] = React.useState('BlockName');
    const [openSnackBar, setOpenSnackBar] = React.useState(false);
    const [clickedButtonGenerate, setClickedButtonGenerate] = React.useState(false);
 
    const [componentsInfo, setComponentsInfo] = React.useState([]);
    const [rowsComponentsIds, setRowsComponentsIds] = React.useState([])
    const [deleteComps, setDeleteComps] = React.useState([])
    
    //  This useEffect adds to the grapesJs commands the `open edit form pop up window` command            
    useEffect( () => {

        if(init === false && editor.BlockManager !== undefined){
            editor.Commands.add("edit-data-element-form", {
                run(){
                    savedPageClicked();
                    setClickedEdit(true);
                }
            })
            setInit(true);
        }

    })

    /*
    This useEffect is runed when edit form pop up window is opened.It parses  the info of the type  and the id of the components inside 
    the rows of the form
    */
    useEffect( () => {

        if(clickedEdit === true  ){
            setProducedBlockName('Block Name');
            setOpenAlert(true);
            setClickedEdit(false);
            setAdded(false);
            setDeleteComps([]);
            const selectedComponent = editor.getSelected();
            
            const tempComponentsInfo = [];
            const tempRowsComponentsIds = [];
            setClickedButtonGenerate(false);

            selectedComponent.attributes.components.models.forEach( (formField) => {
                
                if( formField.attributes.tagName === 'div' ){
                    
                    tempComponentsInfo.push({'div': [], info: []});
                    tempRowsComponentsIds.push({'id': formField.ccid, insideIds:[] })

                    formField.attributes.components.models.forEach( (insideComponent)=> {
                        const componentIndex = tempComponentsInfo.length-1; 
                        
                        if( insideComponent.attributes.tagName === 'button'){
                            
                            tempComponentsInfo[componentIndex].div.push('button');
                            tempComponentsInfo[componentIndex].info.push({method: 'GET',label: '', href: '', target_page: ''})
                            tempRowsComponentsIds[componentIndex].insideIds.push(insideComponent.ccid);
                        }
                        
                        else if(insideComponent.attributes.tagName === 'textarea'){
                            tempComponentsInfo[componentIndex].div.push('textarea');
                            tempComponentsInfo[componentIndex].info.push({placeholder: '', required: false})
                            tempRowsComponentsIds[componentIndex].insideIds.push(insideComponent.ccid);
                        }
                        else if(insideComponent.attributes.attributes.wablitype === 'radios'){

                            const indexRadios = checkIfRadiosExist(tempComponentsInfo[componentIndex].div)

                            if(indexRadios === -1){
                                tempComponentsInfo[componentIndex].div.push('radio');
                                tempComponentsInfo[componentIndex].info.push({labels: [], ids: [insideComponent.ccid]});
                            
                                tempRowsComponentsIds[componentIndex].insideIds.push(insideComponent.ccid);
                            }
                            else{
                                tempComponentsInfo[componentIndex].info[indexRadios].ids.push(insideComponent.ccid);
                                tempRowsComponentsIds[componentIndex].insideIds[indexRadios] = insideComponent.ccid;
                            }

                        }
                        else if(insideComponent.attributes.type === 'checkbox'){
                            tempComponentsInfo[componentIndex].div.push('checkbox');
                            tempComponentsInfo[componentIndex].info.push({checked: false});
                            tempRowsComponentsIds[componentIndex].insideIds.push(insideComponent.ccid);
                        }
                        else if(insideComponent.attributes.tagName === 'label'){
                            tempComponentsInfo[componentIndex].div.push('label');
                            tempComponentsInfo[componentIndex].info.push({label: ''})
                            tempRowsComponentsIds[componentIndex].insideIds.push(insideComponent.ccid);
                        }
                        
                        else if(insideComponent.attributes.tagName === 'input'){
                            tempComponentsInfo[componentIndex].div.push('input');
                            tempComponentsInfo[componentIndex].info.push({placeholder: '', required: false, type: ''})
                            tempRowsComponentsIds[componentIndex].insideIds.push(insideComponent.ccid);
                        }
                        else if(insideComponent.attributes.attributes.wablitype === 'dropdown' || insideComponent.attributes.type === 'dropdown'){
                            tempComponentsInfo[componentIndex].div.push('dropdown');
                            tempComponentsInfo[componentIndex].info.push({label: '', options: []})
                            tempRowsComponentsIds[componentIndex].insideIds.push(insideComponent.ccid);
                        }    
                    })
                }
            })
            setRowsComponentsIds(tempRowsComponentsIds);
            setComponentsInfo(tempComponentsInfo);
        }        
    },[clickedEdit])

    
    useEffect( () => {
        if(added === true){
            setAdded(false);
        }
    },[added])
    

    //  This useEffect is runned when the edit form pop up window is opened and it reads the data element name that belongs the edited form
    useEffect( () => {
        if(openAlert === true  && selectedProject > -1 && selectedPage > -1 ){
            if(editor.getSelected().attributes.attributes.wabliname !== undefined){
                setDataElementName(editor.getSelected().attributes.attributes.wabliname);
            }
            else if(editor.getSelected().attributes.type !== ''){
                setDataElementName(editor.getSelected().attributes.type);
            }
            else{
                setDataElementName(editor.getSelected().attributes.tagName);
            }
            
            
        }
    },[openAlert])

    

    /*
    This function fires when we clicked on a row option of the add new row option and it adds a new row to the edited pop up.
    */
    const addElement = (option) => {
               
        const tempComponentsInfo = [...componentsInfo];
        const tempRowsComponentsIds = [...rowsComponentsIds];

        if(option === 'input type'){
            
            const lengthRows = tempComponentsInfo.length;
            tempComponentsInfo.push({'div': [], info: []});
            tempRowsComponentsIds.push({'id': -1, insideIds:[] })
            tempComponentsInfo[lengthRows].div.push('label');
            tempComponentsInfo[lengthRows].info.push({label: 'Name'})
            tempRowsComponentsIds[lengthRows].insideIds.push(-1);
            tempComponentsInfo[lengthRows].div.push('input');
            tempComponentsInfo[lengthRows].info.push({placeholder: 'Type here your name', required: false, type: 'text'})
            tempRowsComponentsIds[lengthRows].insideIds.push(-1);
        }
        else if (option === 'radio type'){

            const lengthRows = tempComponentsInfo.length;
            
            tempComponentsInfo.push({'div': [], info: []});
            tempRowsComponentsIds.push({'id': -1, insideIds:[] })

            tempComponentsInfo[lengthRows].div.push('label');
            tempComponentsInfo[lengthRows].info.push({label: 'Gender'})
            tempRowsComponentsIds[lengthRows].insideIds.push(-1);


            tempComponentsInfo[lengthRows].div.push('radio');
            tempComponentsInfo[lengthRows].info.push({labels: ['M','F'], labels2: ['M', 'F'], ids: [-1,-1]});
            tempRowsComponentsIds[lengthRows].insideIds.push(-1);
        }
        else if (option === 'textarea type'){
           
            const lengthRows = tempComponentsInfo.length;
            tempComponentsInfo.push({'div': [], info: []});
            tempRowsComponentsIds.push({'id': -1, insideIds:[] })
            tempComponentsInfo[lengthRows].div.push('label');
            tempComponentsInfo[lengthRows].info.push({label: 'Textarea'})
            tempRowsComponentsIds[lengthRows].insideIds.push(-1);
            tempComponentsInfo[lengthRows].div.push('textarea');
            tempComponentsInfo[lengthRows].info.push({placeholder: '', required: false})
            tempRowsComponentsIds[lengthRows].insideIds.push(-1);
        }
        else if( option === 'button type'){
            
            const lengthRows = tempComponentsInfo.length;
            tempComponentsInfo.push({'div': [], info: []});
            tempRowsComponentsIds.push({'id': -1, insideIds:[] })
            tempComponentsInfo[lengthRows].div.push('button');
            tempComponentsInfo[lengthRows].info.push({method: 'GET',label: 'Send', href: '', target_page: ''})
            tempRowsComponentsIds[lengthRows].insideIds.push(-1);
        }
        
        setComponentsInfo(tempComponentsInfo);
        setRowsComponentsIds(tempRowsComponentsIds);
        setAdded(true);

    }

    return(
        <>
            <ServiceDialog
                open={openAlert}
                keepMounted
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >       

                    {clickedButtonGenerate !== true ?
                        <div>
                            {editor !== undefined && editor.getSelected !== undefined && editor.getSelected() !== undefined
                            ?
                                <div className={clsx('titlePopUp','paddingTitle')}> 
                                    Edit data element
                                    <div aria-hidden="true" onClick={() => {setOpenAlert(false)}} className={clsx('pop-up-close-btn')}>x</div>
                                </div>
                            :
                                null

                            }
                            <div className ='paddingTitle'>
                                <div className={clsx('flexRowDirection', 'spacingTopDiv')}> 
                                    <div className={clsx('lightBlue')}> Name: &nbsp; </div>   
                                    <div> {dataElementName} </div>
                                </div> 
                                <div>
                                    {openAlert === true ?
                                        componentsInfo.map( (row,index) => 
                                            <FormRowComponent
                                                index={index}
                                                editor={editor}
                                                componentsInfo={componentsInfo}
                                                setComponentsInfo={setComponentsInfo}
                                                setAdded={setAdded}
                                                added={added}
                                                clickedEdit={clickedEdit}
                                                rowsComponentsIds={rowsComponentsIds}
                                                setRowsComponentsIds={setRowsComponentsIds}
                                                deleteComps={deleteComps}
                                                setDeleteComps={setDeleteComps}
                                                selectedProject={selectedProject}
                                            />
                                        )
                                        :
                                        null

                                    }
                                </div>
                                <DropdownMechanismFixLabel
                                    ElementTypes={ElementTypes}
                                    addElement={addElement}
                                    label ='Add new row'
                                />     
                                <EditFormFunctionsRow
                                    setOpenAlert={setOpenAlert}
                                    setClickedEdit={setClickedEdit}
                                    editor={editor}
                                    componentsInfo={componentsInfo}
                                    rowsComponentsIds={rowsComponentsIds}
                                    deleteComps={deleteComps}
                                    savedPageClicked={savedPageClicked}
                                    setClickedButtonGenerate={setClickedButtonGenerate}
                                    selectedProject={selectedProject}
                                />
                            </div>
                        </div>
                    :
                        <GenerateFormBlock
                            producedBlockName={producedBlockName}
                            setProducedBlockName={setProducedBlockName}
                            setClickedButtonGenerate={setClickedButtonGenerate}
                            editor={editor}
                            selectedProject={selectedProject}
                            dataElementName={dataElementName}
                            componentsInfo={componentsInfo}
                            setOpenSnackBar={setOpenSnackBar}
                            setOpenAlert={setOpenAlert}
                            setClickedEdit={setClickedEdit}
                        />
                    }

            </ServiceDialog>
            <CreateDataElementSnackBar
                open={openSnackBar}
                setOpen={setOpenSnackBar}
                editElement='true'
            /> 
        </>
    )

}

export default EditPopUpForm;